<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col xs="12" md="4">
                <v-row justify="center">
                  <v-avatar min-height="100%" size="120" class="mx-auto">
                    <v-img src="/img/contacto/map.jpg"></v-img>
                  </v-avatar>
                </v-row>
              </v-col>
              <v-col xs="12" md="8">
                <p class="headline px-1">Dirección</p>
                <p class="subtitle px-1">4ta calle 0-10. Zona 2. Paraje Parramón</p>
                <v-btn
                  dark
                  color="secondary"
                  href="https://goo.gl/maps/asQrarG2RhCnmUct8"
                  target="_blank"
                  block
                  class="px-1 primary--text"
                >
                  <v-icon left>fas fa-map-marked-alt</v-icon>
                  Abrir ubicación
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-for="item in cards" :key="item.title">
        <v-card outlined>
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col xs="12" md="4">
                <v-row justify="center">
                  <v-avatar min-height="100%" size="120" class="mx-auto">
                    <v-img :src="item.img"></v-img>
                  </v-avatar>
                </v-row>
              </v-col>
              <v-col xs="12" md="8">
                <p class="headline px-1">{{item.title}}</p>
                <p class="subtitle px-1">{{item.subtitle}}</p>
                <v-btn
                  dark
                  :color="item.color"
                  :href="item.link"
                  v-bind:target="item.blank ? '_blank' : ''"
                  block
                  class="px-1"
                  v-bind:class="item.btnColor"
                >
                  <v-icon left>{{item.icon}}</v-icon>
                  {{item.action}}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      cards: [
        {
          title: 'Cabinas de radio',
          subtitle: 'Cabina de radio 7766-5246',
          link: 'tel:+50277665246',
          icon: 'fas fa-phone',
          action: 'llamar',
          color: 'secondary',
          btnColor: 'primary--text',
          blank: false,
          img: '/img/contacto/cabina.jpg'
        },
        {
          title: 'Oficina',
          subtitle: 'Oficinas centrales 7766-1711',
          link: 'tel:+50277661711',
          icon: 'fas fa-phone',
          action: 'llamar',
          color: 'secondary',
          btnColor: 'primary--text',
          blank: false,
          img: '/img/contacto/oficina.jpg'
        },
        {
          title: 'Whatsapp',
          subtitle: 'Escribenos por whatsapp 4476-4457',
          link: 'https://wa.me/50244764457',
          icon: 'fab fa-whatsapp',
          action: 'Whatsapp',
          color: 'teal',
          btnColor: 'white--text',
          blank: true,
          img: '/img/contacto/whatsapp.jpg'
        },
        {
          title: 'Internacional',
          subtitle: 'Llamadas internacionales 713-242-1901',
          link: 'tel:7132421901',
          icon: 'fas fa-phone',
          action: 'llamar',
          color: 'secondary',
          btnColor: 'primary--text',
          blank: false,
          img: '/img/contacto/internacional.jpg'
        },
        {
          title: 'Escucha la radio por llamada USA',
          subtitle: 'Llama sin costo desde Estados Unidos 641-741-0308',
          link: 'tel:6417410308',
          icon: 'fas fa-phone',
          action: 'llamar',
          color: 'secondary',
          btnColor: 'primary--text',
          blank: false,
          img: '/img/contacto/usa.jpg'
        },
        {
          title: 'Escucha la radio por llamada Canadá',
          subtitle: 'Llama sin costo desde Canadá 605-562-0314',
          link: 'tel:6055620314',
          icon: 'fas fa-phone',
          action: 'llamar',
          color: 'secondary',
          btnColor: 'primary--text',
          blank: false,
          img: '/img/contacto/canada.jpg'
        },
        {
          title: 'Escucha la radio por llamada Puerto Rico',
          subtitle: 'Llama sin costo desde Puerto Rico 641-793-4523',
          link: 'tel:6417934523',
          icon: 'fas fa-phone',
          action: 'llamar',
          color: 'secondary',
          btnColor: 'primary--text',
          blank: false,
          img: '/img/contacto/puerto-rico.jpg'
        }
      ]
    }
  }
}
</script>
